module.exports = __webpack_public_path__ + "img/ico_member.a83dc228.png";